"use client";

import { DbConnection } from "@/module_bindings";
import { getSpacetimeToken } from "@/app/actions";

/**
 * Open a live connection to the Portal SpacetimeDB for the current stage.
 * Authenticates with the user's OpenAuth JWT when present (anonymous otherwise).
 */
export async function connectPortalSpacetime(): Promise<DbConnection> {
  const token = await getSpacetimeToken();
  const uri = process.env.NEXT_PUBLIC_PORTAL_STDB_URI;
  const dbName = process.env.NEXT_PUBLIC_PORTAL_STDB_DB;

  if (!uri || !dbName) {
    throw new Error(
      "NEXT_PUBLIC_PORTAL_STDB_URI and NEXT_PUBLIC_PORTAL_STDB_DB must be set",
    );
  }

  return new Promise<DbConnection>((resolve, reject) => {
    DbConnection.builder()
      .withUri(uri)
      .withDatabaseName(dbName)
      .withToken(token ?? undefined)
      .onConnect((conn) => resolve(conn))
      .onConnectError((_ctx, err) =>
        reject(err instanceof Error ? err : new Error(String(err))),
      )
      .build();
  });
}

/** Builder for SpacetimeDBProvider — the provider owns connect/retain/release. */
export function buildPortalSpacetimeBuilder(token: string | null) {
  const uri = process.env.NEXT_PUBLIC_PORTAL_STDB_URI;
  const db = process.env.NEXT_PUBLIC_PORTAL_STDB_DB;
  if (!uri || !db) {
    throw new Error(
      "NEXT_PUBLIC_PORTAL_STDB_URI and NEXT_PUBLIC_PORTAL_STDB_DB must be set",
    );
  }
  return DbConnection.builder()
    .withUri(uri)
    .withDatabaseName(db)
    .withToken(token ?? undefined);
}
